<template>
  <div class="create-admin">
    <div class="bg-white">
      <div
        class="flex justify-between items-stretch shadow-border-b mdmax:flex-col"
      >
        <div
          class="flex-1 shadow-border-r p-6 mdmax:shadow-border-b mdmax:w-full mdmax:flex-auto"
        >
          <div class="mb-6 relative">
            <div class="" v-if="image">
              <div
                class="border overflow-hidden rounded-full flex justify-center items-center w-32 h-32 text-center"
              >
                <img :src="image" />
              </div>
            </div>
            <div class="image-upload" v-else>
              <input
                type="file"
                name="photo"
                id="photo"
                accept=".jpg, .png, .jpeg"
                ref="photo"
                @change="handleFileSelect($event)"
                class="hidden"
              />
              <label
                for="photo"
                class="border border-dashed p-6 rounded-full flex justify-center items-center border-neutral-500 text-neutral-500 w-32 h-32 text-center cursor-pointer"
              >
                Upload Photo
              </label>
            </div>
          </div>
          <div class="mb-6">
            <TextField
              type="text"
              v-model="name"
              label="Nama"
              placeholder="Nama"
            />
          </div>
          <div class="mb-6 relative">
            <label class="text-sm text-neutral-700 font-medium mb-1 block"
              >Jenis Kelamin</label
            >
            <div class="flex items-center pl-2">
              <input
                type="radio"
                id="one"
                value="M"
                name="gender"
                v-model="gender"
                class="cursor-pointer"
              />
              <label for="one" class="text-sm pl-2 cursor-pointer"
                >Laki-laki</label
              >
            </div>
            <div class="flex items-center pl-2">
              <input
                type="radio"
                id="two"
                value="F"
                name="gender"
                v-model="gender"
                class="cursor-pointer"
              />
              <label for="two" class="text-sm pl-2 cursor-pointer"
                >Perempuan</label
              >
            </div>
          </div>
          <div class="mb-6">
            <TextField
              type="text"
              v-model="email"
              label="Email"
              placeholder="Alamat Email"
            />
          </div>
          <div class="mb-6">
            <TextField
              type="number"
              v-model="phoneNumber"
              label="No Handphone"
              placeholder="No Handphone"
            />
          </div>
          <div class="mb-6">
            <label
              class="text-sm text-neutral-700 font-medium mb-1 inline-block"
              >Partner</label
            >
            <CustomSelect
              :options="partnerList"
              v-model="selectedPartner"
              placeholder="Pilih partner"
              optionLabel="name"
            />
          </div>
        </div>
        <div class="flex-1 mdmax:w-full mdmax:flex-auto p-6">
          <div class="mb-6">
            <TextField type="text" v-model="username" label="Username" />
          </div>
          <div class="mb-6">
            <TextField type="text" v-model="password" label="Password" />
          </div>
          <div class="mb-6">
            <label
              class="text-sm text-neutral-700 font-medium mb-1 inline-block"
              >Role</label
            >
            <CustomSelect
              :options="roleList"
              v-model="selectedRole"
              placeholder="Pilih partner"
              optionLabel="name"
            />
          </div>
        </div>
      </div>
      <div class="w-full bg-white p-6">
        <div class="flex gap-6 justify-end">
          <div class="">
            <Button buttonText="Simpan" type="primary" @action="save()" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex"
export default {
  components: {
    TextField: () =>
      import(/* webpackChunkName: "Forms" */ "@/components/Forms/TextField"),
    Button: () =>
      import(/* webpackChunkName: "Forms" */ "@/components/Forms/Button"),
    CustomSelect: () =>
      import(/* webpackChunkName: "Forms" */ "@/components/Forms/CustomSelect")
  },
  data: () => ({
    selectedPartner: "",
    selectedRole: "",
    name: "",
    username: "",
    password: "",
    loginType: "userpass",
    email: "",
    phoneNumber: "",
    profileImage: "",
    page: 1,
    totalPages: 10,
    total: 100,
    perPage: 10,
    currentPage: 1,
    gender: "M",
    image: ""
  }),
  computed: {
    ...mapGetters("partner", ["partnerList"]),
    ...mapGetters("role", ["roleList"])
  },
  created() {
    this.getPartnerList()
    this.getRole()
  },
  methods: {
    ...mapActions("partner", ["getPartners"]),
    ...mapActions("admin", ["createAdmin"]),
    ...mapActions("common", [
      "showLoading",
      "hideLoading",
      "uploadImage",
      "setToast"
    ]),
    ...mapActions("role", ["getRoleList"]),
    handleFileSelect(event) {
      this.showLoading()
      let imageData = new FormData()
      imageData.append("image", event.target.files[0])
      imageData.append("file_purpose", "avatar")
      this.uploadImage({ payloads: imageData }).then((res) => {
        this.hideLoading()
        this.image = res.file_url
      })
    },
    optionKey(key) {
      return key.code + key.name + Math.random()
    },
    getPartnerList(searchTerm = "") {
      this.getPartners({
        params: {
          page: this.currentPage,
          per_page: this.perPage,
          search_keyword: searchTerm,
          sort: "DESC"
        }
      })
    },
    getRole(searchTerm = "") {
      this.getRoleList({
        params: {
          page: this.currentPage,
          per_page: this.perPage,
          search_keyword: searchTerm
        }
      })
    },
    save() {
      this.showLoading()
      const payloads = {
        name: this.name,
        partner_id: this.selectedPartner.id,
        username: this.username,
        password: this.password,
        login_type: this.loginType,
        email: this.email,
        phone_number: this.phoneNumber,
        profile_image: this.image,
        gender: this.gender,
        role_id: this.selectedRole.id
      }

      this.createAdmin({
        payloads: payloads
      })
        .then(() => {
          this.hideLoading()
          this.setToast({
            options: {
              type: "success",
              duration: 2000,
              primaryText: "Penambahan Partner Logistik Berhasil",
              secondaryText: "Data telah kami simpan",
              callback: this.handleCallback
            }
          })
        })
        .catch(() => {
          this.hideLoading()
          this.setToast({
            options: {
              type: "danger",
              duration: 2000,
              primaryText: "Penambahan User Gagal",
              secondaryText: "Silakan coba lagi.",
              callback: this.handleCallback
            }
          })
        })
    },
    handleCallback() {
      this.$router.push("/admin")
    }
  }
}
</script>
<style lang="scss" scoped>
.create-partner {
  &::v-deep .vs__search {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    padding-left: 0.75rem;
    padding-right: 0.75rem;
    border-radius: 0.5rem;
  }
  &::v-deep .vdpComponent {
    font-size: 16px;
    display: block;
  }
  &::v-deep .vdpComponent input {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    padding-left: 0.75rem;
    padding-right: 0.75rem;
    border-radius: 0.5rem;
    border-color: rgba(206, 213, 222, 1);
    border-width: 1px;
    border-style: solid;
    width: 100%;
  }
}
input:checked[type="checkbox"] + span {
  left: 1.5rem;
  top: 0;
  background-color: #f2994a;
}
input:checked[type="checkbox"]:disabled {
  background-color: rgba(25, 21, 255, 0.5);
}
input:checked[type="checkbox"]:disabled + span {
  background-color: rgb(93, 91, 233);
  box-shadow: none;
}
input[type="checkbox"]:disabled + span {
  background-color: rgb(214, 211, 211);
  box-shadow: none;
}
</style>
